<template>

  <div id="app_content" class="admin admin-media">

    <h1 class="mt-0">Gestione media</h1>

    <section class="header">

      <div class="filters">

        <span>Filtra i file</span>

        <v-select v-model="filter"
          :options="filter_types"
          :clearable="false"
          :searchable="false"
          :reduce="option => option.value"
          @input="loadMedia(true)" />

      </div>

      <button class="add-media belt-btn" @click="add_media = true">Aggiungi file</button>

    </section>

    <div class="media-list" :class="{v_loading: loading}" v-if="media_list && media_list.length > 0">

      <ul>

        <li v-for="media in media_list" :key="media.id">
          <single-media :media="media"/>
        </li>

      </ul>

      <button @click="loadMedia()" 
        class="belt-btn animted" 
        :class="{v_loading: loading}"
        v-if="showButton">Carica di più</button>

    </div>

    <p v-else class="empty">Nessun media ancora caricato...</p>

    <add-media v-if="add_media"/>

  </div>
  
</template>

<script>
import addMedia from './add-media.vue'
import singleMedia from './single-media.vue'

export default{

  components: { addMedia, singleMedia },

  data: function(){

    return {
      loading: false,
      media_list: [],
      add_media: false,
      meta: null,
      filter: null,
      filter_types: [
        {
          label: 'Tutti i file',
          value: null
        },
        {
          label: 'Solo documenti',
          value: 'document'
        },
        {
          label: 'Solo immagini',
          value: 'image'
        }
      ]
    }

  },

  computed: {

    showButton: function(){

      return this.meta.current_page < this.meta.last_page;

    },

    nextPage: function(){

      return this.meta != null ? (this.meta.current_page + 1) : 1;

    }

  },

  methods: {

    /**
     * Prima richiesta dei media senza filtri impostati
     */
    loadMedia: function(filter = false){

      var vue = this;
      vue.loading = true;

      axios({
        method: "get",
        url: window.location.origin + '/data/media/get',
        params: {
          page: filter ? 1 : vue.nextPage,
          filter: vue.filter
        }
      })
      .then(res => {

        // passaggio dei media all'istanza vue
        if( !filter ){

          _.forEach(res.data.data, media => {
            vue.media_list.push( media );
          });

        } else{

          vue.media_list = res.data.data

        }

        // update meta info
        vue.meta = res.data.meta;

      })
      .catch(err => {

        console.log(err.response.data.message);

        vue.$store.commit('add_message', {
          type: 'error',
          message: err.response.data.message
        });
        
      })
      .then(() =>{
        vue.loading = false;
      })

    },

  },

  mounted: function(){

    this.loadMedia();

  }

}
</script>

<style scoped lang="scss">
.header{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.filters{
  width: 100%;
  max-width: 250px;
}
button.add-media{
  max-width: 200px;
  padding: 10px;
  margin: 0 0 0 auto;
}
.media-list{
  width: 100%;
  height: auto;
  margin-top: 2em;
}
.media-list ul{
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.media-list ul li{
  width: 25%;
  max-width: 400px;
  min-width: 250px;
  height: auto;
  position: relative;
  padding: 15px;
}
.empty{
  width: 100%;
  text-align: center;
  margin-top: 2em;
}
</style>
